<template>
  <b-container style="margin-top:15px">
    <b-row>
      <b-card-group deck>
        <b-card header="Kullanıcı Ekle" header-tag="header">
            <b-row>
              <b-col cols="3">
                  <b-form-group label="İsim">
                    <b-form-input size="sm" v-model="form.name" placeholder="İsim"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Soyisim">
                    <b-form-input size="sm" v-model="form.surname" placeholder="Soyisim"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label="Firma">
                  <b-form-select size="sm" v-model="form.client_id" class="form-control mb-3 form-control-sm"  placeholder="Ödeme Notunuz">
                    <b-form-select-option disabled :value="null">Seçiniz</b-form-select-option>
                    <b-form-select-option :value="item.id" v-for="(item,key) in clients" :key="key">{{ item.title }}</b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Kullanıcı Türü">
                    <b-form-select size="sm" v-model="form.type" class="form-control mb-3 form-control-sm"  placeholder="Kullanıcı türü">
                      <b-form-select-option disabled :value="null">Seçiniz</b-form-select-option>
                      <b-form-select-option value="2">Bireysel</b-form-select-option>
                      <b-form-select-option value="1">Kurumsal</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Email">
                    <b-form-input type="email" size="sm" v-model="form.email" placeholder="Email"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Şifre">
                    <b-form-input type="password" size="sm" v-model="form.password" placeholder="Şifre"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Şifreniz Tekrar">
                    <b-form-input type="password" size="sm" v-model="form.password_confirmation" placeholder="Şifreniz Tekrar"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Telefon">
                    <b-form-input type="number" size="sm" v-model="form.phone" placeholder="05551234455"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Vergi Dairesi">
                    <b-form-input size="sm" v-model="form.tax" placeholder="Vergi Dairesi"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3" v-if="form.type == 2">
                  <b-form-group label="T.C Kimlik Numarası">
                    <b-form-input type="number" size="sm" onKeyDown="if(this.value.length==11 && event.keyCode!=8) return false;" v-model="form.identity_id" placeholder="T.C Kimlik Numarası"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3" v-if="form.type == 1">
                  <b-form-group label="Vergi Numarası">
                    <b-form-input type="number" onKeyDown="if(this.value.length==10 && event.keyCode!=8) return false;"  size="sm" v-model="form.tax_number" placeholder="Vergi Numarası"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Adres">
                    <b-form-input size="sm" v-model="form.address" placeholder="Adres"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group style="margin-top:29px">
                    <b-button @click="send()" style="width:100%" variant="primary" size="sm">Ekle</b-button>
                  </b-form-group>
              </b-col>
            </b-row>
        </b-card>
      </b-card-group>
    </b-row>
  </b-container>
</template>

<script>
  export default{
    name: 'UsersCreate',
    data(){
      return{
        loading: false,
        clients:null,
        form:{
          name:null,
          surname:null,
          email:null,
          password:null,
          password_confirmation:null,
          phone:null,
          tax:null,
          client_id:null,
          tax_number:null,
          address:null,
          identity_id:null, 
          type:null,
        }
      }
    },
    created(){
      this.fetchPayments();
    },
    methods:{
      fetchPayments(){
        axios.get('/list/clients')
        .then((response) => {
            this.clients = response.data.data;
        })
        .catch((err) => {
        })
        .finally(()=>{
        });
      },
      send(){
        this.loading = true;
        axios.post('/users/create', this.form)
        .then((response) => {
            this.$store.dispatch('alert/message', { type: 'warning', title: 'Ekleme Başarılı'});
            this.$router.push({name: 'Users'});
        })
        .catch((err) => {
        })
        .finally(()=>{
            this.loading = false;
        })
      },
    }
  }
</script>